import { render, staticRenderFns } from "./SubtitleEditor.vue?vue&type=template&id=6b6eafea&"
import script from "./SubtitleEditor.vue?vue&type=script&lang=js&"
export * from "./SubtitleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubtitleEditor.vue"
export default component.exports